var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 46C35.9264 46 46 35.9264 46 23.5C46 11.0736 35.9264 1 23.5 1C11.0736 1 1 11.0736 1 23.5C1 35.9264 11.0736 46 23.5 46Z",
    fill: "#E6E8EC",
    stroke: "#E1E1E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0175,
    y: 11.9172,
    width: 24.0657,
    height: 23.1657,
    stroke: "#E1E1E1",
    strokeWidth: 0.234278
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2004 13.5852L31.1367 11.8L23.5088 29.0892L16.9625 22.3908L21.895 20.2356C21.895 20.2356 23.162 19.7011 23.162 18.2244C23.162 16.9995 22.1662 16.0076 20.9404 16.0076C20.4751 16.0076 20.1404 16.1566 20.1404 16.1566L12.1777 19.6634C12.1777 19.6634 10.9004 20.2134 10.9004 21.6558C10.9004 22.6495 11.4858 23.1857 11.4858 23.1857L22.5371 34.4291C22.5371 34.4291 23.2255 35.2 24.2196 35.2C25.7269 35.2 26.3072 33.7576 26.3072 33.7576L35.2004 13.5852Z",
    fill: "#FF2A00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.60f5a035449d044f0e0de522f8bdddcf.svg";
export { ForwardRef as ReactComponent };